var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99956 5.03955C6.84917 5.03955 4.54253 6.63721 2.91558 10.0005C4.54253 13.3638 6.84917 14.9614 9.99956 14.9614C13.1519 14.9614 15.4585 13.3638 17.0835 10.0005C15.4566 6.63721 13.15 5.03955 9.99956 5.03955ZM9.92144 13.438C8.023 13.438 6.48394 11.8989 6.48394 10.0005C6.48394 8.10205 8.023 6.56299 9.92144 6.56299C11.8199 6.56299 13.3589 8.10205 13.3589 10.0005C13.3589 11.8989 11.8199 13.438 9.92144 13.438Z",
    fill: "#E6F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4018 9.49658C16.5503 5.59619 13.7515 3.6333 9.9995 3.6333C6.2456 3.6333 3.44872 5.59619 1.59716 9.49854C1.52289 9.65579 1.48438 9.82755 1.48438 10.0015C1.48438 10.1754 1.52289 10.3471 1.59716 10.5044C3.44872 14.4048 6.24755 16.3677 9.9995 16.3677C13.7534 16.3677 16.5503 14.4048 18.4018 10.5024C18.5522 10.186 18.5522 9.81885 18.4018 9.49658ZM9.9995 14.9614C6.84911 14.9614 4.54247 13.3638 2.91552 10.0005C4.54247 6.63721 6.84911 5.03955 9.9995 5.03955C13.1499 5.03955 15.4565 6.63721 17.0835 10.0005C15.4585 13.3638 13.1518 14.9614 9.9995 14.9614Z",
    fill: "#1890FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92133 6.56299C8.0229 6.56299 6.48383 8.10205 6.48383 10.0005C6.48383 11.8989 8.0229 13.438 9.92133 13.438C11.8198 13.438 13.3588 11.8989 13.3588 10.0005C13.3588 8.10205 11.8198 6.56299 9.92133 6.56299ZM9.92133 12.188C8.71235 12.188 7.73383 11.2095 7.73383 10.0005C7.73383 8.7915 8.71235 7.81299 9.92133 7.81299C11.1303 7.81299 12.1088 8.7915 12.1088 10.0005C12.1088 11.2095 11.1303 12.188 9.92133 12.188Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon-eye.d99965b1c32128fbf56e8627de8668f3.svg";
export { ForwardRef as ReactComponent };